// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import 'babel-polyfill'
import router from './router'
import store from './store'
import iView from 'iview'; //引入iview
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'iview/dist/styles/iview.css'; //引入iview的css样式文件，后面如果需要自己配置也可以新建文件进行修改
import "./assets/global.css";
import 'animate.css'
import 'swiper/swiper-bundle.css'

Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.config.productionTip = false
Vue.use(iView); //use使用这个插件
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js